export default __webpack_public_path__ + "static/media/unsplash-1.f6b3aeb0.jpg";